const DEFAULT_VISUALIZER_ASSET_BASE_URL = 'https://cos.carrus2049.com/automixMinisite/visualizer'

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/g, '')
}

function trimLeadingSlash(value: string): string {
  return value.replace(/^\/+/g, '')
}

export const VISUALIZER_ASSET_BASE_URL = trimTrailingSlash(
  import.meta.env.VITE_VISUALIZER_ASSET_BASE_URL || DEFAULT_VISUALIZER_ASSET_BASE_URL
)

export function getVisualizerAssetUrl(assetPath: string): string {
  return `${VISUALIZER_ASSET_BASE_URL}/${trimLeadingSlash(assetPath)}`
}
